<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img
          class="confectionModal-image img-responsive"
          alt="envelope example"
          :src="image"
          width="350px"
        >
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Etui na karty z etykietami</h2>
        <section class="confectionModal-descriptions">
          <h5>Eleganckie etui nada prezentowi jeszcze bardziej prestiżowy wygląd i indywidualny charakter!</h5>
          <p>Na etui mogą zostać nadrukowane takie informacje jak imię, nazwisko, kwota zasilenia.</p>
        </section>
        <section>
          <p>
            <a :href="file" target="_blank" class="text-underline">Pobierz szablon</a>
            , aby uzupełnić dane, które zostaną nadrukowane na etui. Plik będziesz mógł załączyć w kroku „DOSTAWA”.
          </p>
        </section>
        <section class="confectionModal-warnings">
          <p>
            UWAGA! Liczba zamawianych etui z etykietami musi być zgodna z liczbą rekordów w pliku excel. Liczba zamawianych etui z etykietami musi być dokładnie taka sama jak liczba zamawianych kart.
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'etuiCardModal',
  props: {
    image: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
